import React from 'react';
import { Star } from 'lucide-react';

export const TestimonialCard = ({ testimonial }) => (
  <div
    className="bg-black/60 border border-[#D4AF37]/20 rounded-2xl p-6 hover:border-[#D4AF37]/40 transition-colors duration-200"
    data-testid={`testimonial-card-${testimonial.name.toLowerCase().split(' ')[0]}`}
  >
    <div className="flex gap-1 mb-4">
      {[...Array(testimonial.rating)].map((_, i) => (
        <Star key={`star-${i}`} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
      ))}
    </div>
    <p className="text-[#E8DCC4] text-sm leading-relaxed mb-6">
      &ldquo;{testimonial.text}&rdquo;
    </p>
    <div>
      <p className="text-white font-medium text-sm">{testimonial.name}</p>
      <p className="text-[#A89B8C] text-xs">{testimonial.location}</p>
    </div>
  </div>
);
